var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.2352 22.5018H7.63516C7.19423 22.5018 6.77137 22.3266 6.45959 22.0148C6.14781 21.703 5.97266 21.2802 5.97266 20.8393C5.97266 20.3983 6.14781 19.9755 6.45959 19.6637C6.77137 19.3519 7.19423 19.1768 7.63516 19.1768H34.2352C34.6761 19.1768 35.0989 19.3519 35.4107 19.6637C35.7225 19.9755 35.8977 20.3983 35.8977 20.8393C35.8977 21.2802 35.7225 21.703 35.4107 22.0148C35.0989 22.3266 34.6761 22.5018 34.2352 22.5018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5843 29.1514C27.2555 29.1513 26.9342 29.0538 26.6608 28.8711C26.3875 28.6884 26.1745 28.4288 26.0487 28.1251C25.9229 27.8213 25.89 27.4871 25.9541 27.1647C26.0182 26.8422 26.1765 26.546 26.4089 26.3135L31.8835 20.8389L26.4089 15.3643C26.2501 15.2109 26.1235 15.0275 26.0363 14.8247C25.9492 14.6218 25.9033 14.4037 25.9014 14.1829C25.8995 13.9622 25.9416 13.7433 26.0252 13.5389C26.1088 13.3346 26.2322 13.149 26.3883 12.9929C26.5444 12.8368 26.73 12.7134 26.9343 12.6298C27.1387 12.5462 27.3576 12.5041 27.5783 12.506C27.7991 12.508 28.0172 12.5538 28.22 12.641C28.4229 12.7281 28.6063 12.8547 28.7597 13.0135L35.4097 19.6635C35.7214 19.9753 35.8964 20.3981 35.8964 20.8389C35.8964 21.2797 35.7214 21.7025 35.4097 22.0143L28.7597 28.6643C28.448 28.9761 28.0252 29.1513 27.5843 29.1514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgArrow);
export default __webpack_public_path__ + "static/media/lgArrow.a47a834abb7df563fcd769bdbdbd74a5.svg";
export { ForwardRef as ReactComponent };